import { useEffect } from "react";
import OrgsAndGroupsSelector from 'app/components/common/OrgsAndGroupsSelector';
import { useOrgsData } from 'app/dataProviders/org/OrgsDataProvider';
import useOrgsSelector from './useOrgsSelector';
import styles from './CopyCheckedSelector.module.scss'

type CopyCheckedSelectorProps = {
  names: Array<string>,
  disabled: boolean,
  show: boolean,
  onChangeSelection: (value: Array<string>) => void,
}

export const CopyCheckedSelector = ({
  names,
  disabled,
  show,
  onChangeSelection,
}: CopyCheckedSelectorProps) => {
  const [{ orgs: orgsState, loading: loadingOrgs, currentOrg }] = useOrgsData();
  const [{ orgs, selection, defaultSelection, onChange }, resetSelection] = useOrgsSelector(orgsState);

  useEffect(() => {
    onChangeSelection(selection);
  }, [onChangeSelection, selection]);

  useEffect(() => {
    if (!show) {
      resetSelection();
    }
  }, [resetSelection, show]);

  return (
    <>
      <label>
        {'Следующая продукция будет скопирована:'}
        <div>
          <ul>
            {names.map(name => <li key={name}>{name}</li>)}
          </ul>
        </div>
      </label>

      <OrgsAndGroupsSelector
        className={styles.orgsSelector}
        orgType={currentOrg.type}
        label="В заведения"
        header="Выберите заведения, куда копировать продукцию"
        pleaseSelectText="Выберите заведение"
        disabled={disabled || loadingOrgs}
        orgs={orgs}
        multiple
        selectedAllOnEmptySelection={false}
        selection={selection}
        defaultSelection={defaultSelection}
        onChange={onChange}
      />
    </>
  );
};
